import type {ReactElement} from 'react';
import React from 'react';
import {Thumbnail} from '@Components/thumbnail';
import {ThumbnailType} from '@Components/thumbnail/thumbnail.types';
import {isUserLoggedIn} from '@Libraries/user.library';
import LogoFull from '@Assets/logo-postermaker.svg';
import LogoMobile from '@Assets/logo-mobile.svg';
import styles from './nav-logo.module.scss';
import {SkeletonBrickTheme} from '@Components/skeleton-brick';

interface NavLogoProps {
  className?: string;
  showFullLogo?: boolean;
  hasSmallLogoMargin?: boolean;
}

export function NavLogo({hasSmallLogoMargin = false, showFullLogo = false, className = ''}: NavLogoProps): ReactElement {
  const getAriaLabel = (): string => {
    if (isUserLoggedIn()) {
      return window.i18next.t('pmwjs_go_to_my_stuff');
    }
    return window.i18next.t('pmwjs_go_to_home_page');
  };

  return (
    <a aria-label={getAriaLabel()} href={window.PMW.util.site_url('')} className={`${styles.relative} flexbox`}>
      <Thumbnail
        data={{
          type: ThumbnailType.IMAGE,
          imageSrc: showFullLogo ? (LogoFull as string) : (LogoMobile as string),
          showSkeletonLoading: true,
          skeletonLoadingTheme: SkeletonBrickTheme.DARK,
        }}
        className={`${className} ${styles.container} ${showFullLogo ? `${styles.fullLogo} spacing-m-r-8` : styles.logoIcon} ${
          hasSmallLogoMargin ? 'spacing-m-r-2' : 'spacing-m-r-5'
        }`}
      />
    </a>
  );
}
